import type { FaireProductEntity } from "../../entity_types/product";

export const p_6nccahugnw: FaireProductEntity = {
  token: "p_6nccahugnw",
  type: "product",
  name: "The Pistachio Hat",
  brandToken: "b_jaxvn3rd8j",
  brandName: "Táche Pistachio Milk",
  imageUrl: "https://cdn.faire.com/fastly/2d6bea5b824a9774d25c496093fdda6fc717cd868d05a4ce4e64447e0cec7c58.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6d535c80d130e1c06e08b188644171d5f034ef34d7c6d053e655375848d155c.png"
  ],
  priceDollars: 35,
  description: "Wear your heart on your sleeve, wear your palate on your hat. A subtly bold statement piece to accompany your great taste in milk. The Pistachio Hat is a deep hunter green design featuring a cream pistachio script for favorite nut flare, all tied together with its adjustable band for the perfect fit.",
  tags: [],
  msrpDollars: 70,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:38.362Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
